//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { isEmpty } from "lodash";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "ConsolidatedRequestBankStatements",
  props: {
    bankStatements: {
      type: Object,
      default: () => ({})
    },
    expandOnInit: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      expandedBankStatements: false
    };
  },
  computed: {
    hasBankStatementRequest() {
      return !isEmpty(this.bankStatements);
    },
    monthsRequested() {
      var _this$bankStatements;
      return ((_this$bankStatements = this.bankStatements) == null ? void 0 : _this$bankStatements.months) || 0;
    },
    emails() {
      var _this$bankStatements2;
      return ((_this$bankStatements2 = this.bankStatements) == null ? void 0 : _this$bankStatements2.emails.join(", ")) || "";
    }
  },
  mounted() {
    this.expandedBankStatements = this.expandOnInit;
  },
  methods: {
    toggleExpandBankStatements() {
      this.expandedBankStatements = !this.expandedBankStatements;
    }
  }
});